(function($) {

	'use strict';
    
    var init = function() {

        var headerHeight = (window.outerWidth > 975) ? 61 : 0;

		var min = 500

		var max = 1500

        $("a[href*='#']:not([href='#'])").click(function() {

			if (
				location.hostname == this.hostname
				&& this.pathname.replace(/^\//,"") == location.pathname.replace(/^\//,"")
			) {
				var anchor = $(this.hash);
				anchor = anchor.length ? anchor : $("[name=" + this.hash.slice(1) +"]");
				if ( anchor.length ) {
					var duration = Math.max(min, Math.min(750 * (Math.abs(anchor.offset().top - window.scrollY) / window.outerHeight), max))
					
						$("html, body").animate( { scrollTop: anchor.offset().top - headerHeight }, duration)
					
				}
			}
        });
    }

	$(document).ready(function() {
		init();
	});

})(jQuery);